export default __webpack_public_path__ + "static/O0195-aede9751272c4acba679cf2949864696.png";